import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import Loader from 'react-simple-loading';
import {
  Box,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { BrokenImage } from '@material-ui/icons';

import SharedContentCoverImage from './SharedContentCoverImage';
import { getImage } from './getImageRequest';
import { getGalleryTempObjectRequest } from './getGalleryTempObjectRequest';
import { getVideo } from './getVideoRequest';


const useStyles = makeStyles((theme) => {
  return {
    errorLoadingContent: {
      backgroundColor: '#e7b4b1',
      color: theme.palette.common.white,
      borderRadius: 20,
      boxSizing: 'border-box',
    },
    contentUnavailable: {
      textAlign: 'center',
      lineHeight: 1,
      marginTop: theme.spacing(1),
    },
  };
});

const PrivateContentMessage = ({ message, onImageLoad, onGalleryCoverClick, onVideoCoverClick }) => {
  const [url, setUrl] = useState('');
  const [err, setErr] = useState(false);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const [ref, inView] = useInView({
    /* Optional options */
    threshold: 0,
  });

  const { details: { privateContent: { images, snapshotUrl, videoId, anchorId, mainImage } } } = message;
  const isVideo = !images;

  const getGalleryMainImage = async() => {
    if (mainImage) {
      setLoading(true);
      const url = await getImage(mainImage);
      if (url) {
        setUrl(url);
      } else {
        setErr(true);
      }
      setLoading(false);
    }
  };

  const retrieveTemporaryVideoUrl = async(anchorId, videoId) => await getVideo(anchorId, videoId);

  const getSharedContentGalleryTempObject = async(url) => await getGalleryTempObjectRequest(url);

  if (inView && !isVideo) {
    if (!url && err === false && loading === false) {
      getGalleryMainImage();
    }
  }

  const clickOnSharedItem = async() => {
    if (isVideo) {
      if (!!videoId && !!anchorId) {
        const tempUrl = await retrieveTemporaryVideoUrl(anchorId, videoId);
        if (tempUrl) {
          onVideoCoverClick(tempUrl);
        }
      }
    } else if (mainImage) {
      // TODO: ugly /thumbnail hack
      const tempUrl = await getSharedContentGalleryTempObject(mainImage.replace('/thumbnail', ''));
      if (tempUrl && tempUrl.images) {
        onGalleryCoverClick(tempUrl.images.map((image) => {
          return { url: image.imageTemporaryUrl, id: image.id };
        }));
      }
    }
  };

  return (
    <React.Fragment>
      <div ref={ref}>
        {isVideo && (
          <SharedContentCoverImage
            isVideoCover={isVideo}
            url={snapshotUrl}
            onClick={clickOnSharedItem}
            onImageLoad={onImageLoad}
          />
        )}
        {!isVideo && url && (
          <SharedContentCoverImage
            galleryImagesCount={images.length}
            isVideoCover={isVideo}
            url={url}
            onClick={clickOnSharedItem}
            onImageLoad={onImageLoad}
          />
        )}
        {!isVideo && !url && (
          <Box height={'27vh'} mb={3}>
            {err && (
              <Box
                alignItems="center"
                className={classes.errorLoadingContent}
                display="inline-flex"
                flexDirection="column"
                height="100%"
                justifyContent="center"
                p={2}
              >
                <BrokenImage fontSize="large" />
                <Typography className={classes.contentUnavailable} variant="body2">
                  Content Unavailable
                </Typography>
              </Box>
            )}
            {!err && <Loader color="black" size="50px" stroke="4px" />}
          </Box>
        )}
      </div>
    </React.Fragment>);
};

export default PrivateContentMessage;
